import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { getIsTimedPlusBiddingOpen } from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';
import { useAppSelector } from '@/redux/hooks';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';
import SearchCardInfo from '@/components/GridItemCard/Card/CardOptions/CategorySearchCards/components/CardInfo/CardInfo';
import theme from '@liveauctioneers/caterwaul-components/lib/theme/theme';
import TimedPlusCardInfo from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/components/CardInfo/CardInfo';
import useIsWiderThan from '@/hooks/useIsWiderThan';

export const DateAndHouseComponent = createInfo<ItemSummary & { position: number }>({
    className: 'line-clamp-0',
    useText: ({ isPassed, isSold, isTimedPlusAuction, itemId, position }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);

        const isMobile = !useIsWiderThan(theme.breakpoints.tabletNarrowWidthNum);
        const isTimedPlusBiddingOpen = useAppSelector((state) => getIsTimedPlusBiddingOpen(state, itemId));
        const isOpenItem = !isPassed && !isSold && isTimedPlusBiddingOpen;

        return (
            <div className="mt-xs">
                {isTimedPlusAuction ? (
                    <TimedPlusCardInfo
                        isMobile={isMobile}
                        isOpenItem={isOpenItem}
                        itemId={itemId}
                        onNavigate={(trigger) => {
                            onNavigateInitiated(trigger, { position });
                        }}
                    />
                ) : (
                    <SearchCardInfo
                        itemId={itemId}
                        onNavigate={(trigger) => {
                            onNavigateInitiated(trigger, { position });
                        }}
                    />
                )}
            </div>
        );
    },
});
